import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import BeastForm from "./components/BeastForm";
import BeastProgress from "./components/BeastProgress";
import BeastResults from "./components/BeastResults";

function Beast() {
  const [jobId, setJobId] = useState(null);
  const [jobData, setJobData] = useState(null);
  const [isRunning, setIsRunning] = useState(false);

  // 輪詢 Job 狀態
  useEffect(() => {
    if (!jobId || !isRunning) return;

    const interval = setInterval(async () => {
      try {
        const response = await fetch(`/api/beast/jobs/${jobId}`);
        const data = await response.json();
        setJobData(data);

        // 如果完成或失敗,停止輪詢
        if (data.status === "SUCCEEDED" || data.status === "BEST_EFFORT" || data.status === "FAILED") {
          setIsRunning(false);
        }
      } catch (error) {
        console.error("Failed to fetch job status:", error);
      }
    }, 2000); // 每 2 秒更新一次

    return () => clearInterval(interval);
  }, [jobId, isRunning]);

  const handleSubmit = async (params) => {
    try {
      const response = await fetch("/api/beast/jobs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params),
      });

      const data = await response.json();
      setJobId(data.jobId);
      setIsRunning(true);
    } catch (error) {
      console.error("Failed to create job:", error);
      alert("建立任務失敗,請稍後再試");
    }
  };

  const handleReset = () => {
    setJobId(null);
    setJobData(null);
    setIsRunning(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Beast AI 策略生成器
                </MDTypography>
              </MDBox>
              <MDBox pt={3} px={3} pb={3}>
                {!jobId ? (
                  <BeastForm onSubmit={handleSubmit} />
                ) : (
                  <>
                    <BeastProgress jobData={jobData} isRunning={isRunning} />
                    {jobData && jobData.status !== "RUNNING" && (
                      <BeastResults jobData={jobData} onReset={handleReset} />
                    )}
                  </>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Beast;
